import type { ReactNode } from 'react'
import './familyCard.css'

export interface FamilyCardProps {
  title?: ReactNode
  bigTitle?: ReactNode
  subtitle?: ReactNode
  photo?: ReactNode
  actions?: ReactNode
  children?: ReactNode
  className?: string
  testId?: string
}

export const FamilyCard = ({
  title,
  bigTitle,
  subtitle,
  photo,
  actions,
  children,
  className,
  testId,
}: FamilyCardProps) => {
  return (
    <div
      className={['familyCard', className].filter(Boolean).join(' ')}
      data-testid={testId}
    >
      {(title || actions) && (
        <div className="familyCard__header">
          {title && <h4 className="familyCard__title">{title}</h4>}
          {actions && <div className="familyCard__actions">{actions}</div>}
        </div>
      )}
      {bigTitle && <div className="familyCard__bigTitle">{bigTitle}</div>}
      {subtitle && <div className="familyCard__subtitle">{subtitle}</div>}
      {photo && <div className="familyCard__photo">{photo}</div>}
      {children && <div className="familyCard__body">{children}</div>}
    </div>
  )
}
